/* eslint-disable react/react-in-jsx-scope */
import * as Yup from 'yup';
import DateFormatter from 'components/DateFormatter';
import { currencyToLocal } from 'utils/constants';

// export const indianAddonsSubscriberColumns = [
//   // {
//   //   accessorKey: 'plan',
//   //   header: 'Plan',
//   //   enableSorting: false,
//   // },
//   // {
//   //   accessorKey: 'tradeName',
//   //   header: 'BUSINESS NAME',
//   //   cell: ({ row }) => <UserInfo name="Hello" mobileNumber="91111111111" />,
//   //   enableSorting: true,
//   // },
//   { accessorKey: 'plan', header: 'PLAN', sort: true },
//   { accessorKey: 'duration', header: 'DURATION',
//   cell: ({ row }) => <>{row?.original?.duration} Days</>,
//   sort: true },
//   { accessorKey: 'amount', header: 'AMOUNT', sort: true },
//   { accessorKey: 'discount_amount', header: 'DISCOUNT AMOUNT', sort: true },

//   {
//     accessorKey: 'createdAt',
//     header: 'CREATED DATE',
//     //   cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
//     sort: true,
//   },
//   {
//     accessorKey: 'createdAt',
//     header: 'MODIFIED DATE',
//     //   cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
//     sort: true,
//   },
//   {
//     accessorKey: 'subscribers',
//     header: 'SUBSCRIBERS',
//     enableSorting: false,
//   },
//   {
//     accessorKey: 'actions',
//     header: '',
//     enableSorting: false,
//   },
// ];

// export const foreignAddonsSubscriberColumns = [
//   { accessorKey: 'plan', header: 'PLAN', sort: true },
//   { accessorKey: 'duration', header: 'DURATION',  cell: ({ row }) => <>{row?.original?.duration} Days</>, sort: true },
//   { accessorKey: 'amount', header: 'AMOUNT', sort: true },
//   { accessorKey: 'discount_amount', header: 'DISCOUNT AMOUNT', sort: true },

//   {
//     accessorKey: 'createdAt',
//     header: 'CREATED DATE',
//     //   cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
//     sort: true,
//   },
//   {
//     accessorKey: 'createdAt',
//     header: 'MODIFIED DATE',
//     //   cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
//     sort: true,
//   },
//   {
//     accessorKey: 'subscribers',
//     header: 'SUBSCRIBERS',
//     enableSorting: false,
//   },
//   {
//     accessorKey: 'actions',
//     header: '',
//     enableSorting: false,
//   },
// ];

export const addOnColumns = [
  { accessorKey: 'planName', header: 'PLAN', sort: true },
  {
    accessorKey: 'price',
    header: 'AMOUNT',
    enableSorting: true,
    cell: ({ row }) => {
      return (
        <div>
          {currencyToLocal(row?.original?.price, row?.original?.currency)}
        </div>
      );
    },
  },
  {
    accessorKey: 'discountedAmount',
    header: 'DISCOUNTED AMOUNT',
    enableSorting: true,
    cell: ({ row }) => {
      return (
        <div className="info text-end me-4">
          <h4 className="f-12 fw-medium mb-0 text-dark ">
            {currencyToLocal(
              row?.original?.discountedAmount,
              row?.original?.currency,
            )}
          </h4>
          <p className="mb-0 mt-1 f-12 font-manrope text-active ">
            {row?.original?.discountedPercentage}%
          </p>
        </div>
      );
    },
  },
  {
    accessorKey: 'duration',
    header: 'DURATION',
    cell: ({ row }) => <>{row?.original?.duration} days</>,
    sort: true,
  },
  { accessorKey: 'status', header: 'STATUS', enableSorting: false },

  {
    accessorKey: 'createdAt',
    header: 'CREATED DATE',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    sort: true,
  },
  {
    accessorKey: 'updatedAt',
    header: 'LAST MODIFIED DATE',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.updatedAt} />,
    sort: true,
  },

  // {
  //   accessorKey: 'subscribers',
  //   header: 'SUBSCRIBERS',
  //   enableSorting: true,
  // },
  { accessorKey: 'actions', header: '', enableSorting: false },
];

export const editAddonsColumns = [
  { accessorKey: 'duration', header: 'DURATION', sort: false },
  { accessorKey: 'amount', header: ' ACTUAL AMOUNT', sort: false },
  { accessorKey: 'discount', header: 'DISCOUNT %', sort: false },
  { accessorKey: 'discount_amount', header: 'DISCOUNT AMOUNT', sort: false },
];

export const editPlanValidationSchema = Yup.object().shape({
  plans: Yup.array().of(
    Yup.object().shape({
      // name: Yup.string().required('Plan Name is required'),
      // price: Yup.number().required('Price is required'),
      discountedPercentage: Yup.number().required('Discount is required'),
      discountedAmount: Yup.number().required('Discount Price is required'),

      // duration: Yup.number().required('Duration is required'),
      // description: Yup.string().required('Description is required'),
    }),
  ),
});
